import { jsx as _jsx } from "react/jsx-runtime";
export const NotetakerIcon = ()=>/*#__PURE__*/ _jsx("img", {
        src: "https://dapulse-res.cloudinary.com/image/upload/AI%20homepage%202026/notetaket_header_icon.svg",
        width: "18",
        height: "18",
        alt: ""
    });
